(function initLrcCartDrawer() {
    const getEls = () => ({
        overlay: document.querySelector('[data-lrc-cart-overlay]'),
        panel: document.querySelector('[data-lrc-cart-panel]')
    });

    const lockScroll = () => document.documentElement.classList.add('cart-drawer-open');
    const unlockScroll = () => document.documentElement.classList.remove('cart-drawer-open');

    function openCart(opener) {
        const { overlay, panel } = getEls();
        if (!overlay || !panel) return;
        overlay.style.opacity = '1';
        overlay.style.pointerEvents = 'auto';
        panel.style.transform = 'translateX(0)';
        panel.setAttribute('aria-hidden', 'false');
        lockScroll();
        requestAnimationFrame(() => {
            const focusable = panel.querySelector('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            focusable && focusable.focus({ preventScroll: true });
        });
        openCart.lastOpener = opener || document.activeElement;
    }

    function closeCart() {
        const { overlay, panel } = getEls();
        if (!overlay || !panel) return;
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
        panel.style.transform = 'translateX(110%)';

        const onEnd = (e) => {
            if (e && e.target !== panel) return;
            panel.removeEventListener('transitionend', onEnd, true);
            panel.setAttribute('aria-hidden', 'true');
            unlockScroll();
            const opener = openCart.lastOpener;
            if (opener && document.contains(opener)) opener.focus?.({ preventScroll: true });
        };
        panel.addEventListener('transitionend', onEnd, true);

        setTimeout(() => {
            panel.removeEventListener('transitionend', onEnd, true);
            panel.setAttribute('aria-hidden', 'true');
            unlockScroll();
        }, 900);
    }

    // Delegated clicks (works if header re-renders)
    document.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-lrc-cart-open]');
        if (openBtn) { e.preventDefault(); openCart(openBtn); return; }
        const closeBtn = e.target.closest('[data-lrc-cart-close]');
        if (closeBtn) { e.preventDefault(); closeCart(); return; }
    });

    // Overlay click closes
    document.addEventListener('click', (e) => {
        const { overlay } = getEls();
        if (overlay && e.target === overlay) { e.preventDefault(); closeCart(); }
    });

    // ESC to close
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeCart();
    });

    // Public API (optional)
    window.lrcCartDrawer = {
        open: () => openCart(), close: closeCart, toggle: () => {
            const { panel } = getEls();
            if (!panel) return;
            const isClosed = getComputedStyle(panel).transform.includes('matrix(1, 0, 0, 1, 0, 0)') === false &&
                panel.style.transform.includes('100%');
            isClosed ? openCart() : closeCart();
        }
    };
})();